import { render, staticRenderFns } from "./nickNameCell.vue?vue&type=template&id=0c8299de"
import script from "./nickNameCell.vue?vue&type=script&lang=js"
export * from "./nickNameCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports